import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { sidemenuFooterWrap } from "../componentCommon";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { getUnitSlugCondition } from "../../actions";
import { baseUrlGet, indArrNorm } from '../../common';

import "../../index.scss";
import "./Responsive.scss";
import "./DocumentView.scss";

const mapStateToProps = state => ({
  dlUnit: state.dlUnit.dlUnit,
  scanInd: state.dlUnit.scanInd
});

const mapDispatchToProps = dispatch => ({
  getUnitSlugCondition: payload => dispatch(getUnitSlugCondition(payload))  
});

const scanUrlGet = (item, ind) => {
  let scanUrl = '';
  const urlBase = baseUrlGet();

  if (item.hasOwnProperty('scans')) {
    // console.log('dlUnit - scans.length');
    // console.log(dlUnit.scans.length);
    if (item.scans.length > 0) {
      ind = indArrNorm(ind, item.scans.length);
      // pdfSrc = dlUnit.scans[0];            
      scanUrl = urlBase + '/stat-u/dl-unit/scan/' + item.fold + '/' + item.scans[ind];    
      // console.log('pdfUrl - 2');
      // console.log(scanUrl);
    }
  }

  return scanUrl;

}

let DocumentView = ({ match, getUnitSlugCondition, dlUnit, scanInd }) => {
  const urlBase = baseUrlGet();
  let idSlug = match.params.hasOwnProperty('idSlug') ? match.params.idSlug : '';
  let pdfUrl = '';  
  pdfUrl = '../full_page_fax_print38.pdf';  
  
  useEffect(
    function() {
      getUnitSlugCondition(idSlug);
    },
    [idSlug]
  );

  useEffect(
    function() {
      if (dlUnit.id + '' != '') {
        // console.log('dlUnit - 2');
        // console.log(dlUnit);
        if (dlUnit.hasOwnProperty('scans')) {
          pdfUrl = scanUrlGet(dlUnit, scanInd);
        }
      }      
    },
    [dlUnit, pdfUrl]
  );

  return (
  <Container
    className="container-document-view"
    sm={{ span: 12 }}
    md={{ span: 12 }}
    lg={{ span: 12 }}
    xl={{ span: 12 }}
  >
    <Row>
      <Col
        sm={{ span: 12 }}
        md={{ span: 9, offset: 1 }}
        lg={{ span: 9, offset: 1 }}
        xl={{ span: 11, offset: 0 }}
      >
        <div className="document-view" >
          <embed src={ scanUrlGet(dlUnit, scanInd) } type="application/pdf"  />
        </div>
      </Col>
    </Row>
  </Container>
);
}

DocumentView = sidemenuFooterWrap(DocumentView);
export default connect(mapStateToProps, mapDispatchToProps)(DocumentView);
